import { injectable } from 'inversify';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IHttpService, IHttpRequest  } from '@/app-modules/http/http-service-interface';
import { IApiConfiguration, ConfigurationBase, ConfigurationKey } from '@/app-modules/config';

@injectable()
class HttpService extends ConfigurationBase implements IHttpService {
    constructor() {
        super();
        const apiConfig = this.getConfigurationItem<IApiConfiguration>(ConfigurationKey.API);
        this.configUrl = apiConfig.url;
        this.netAPIUrl = apiConfig.netAPIUrl;
    }

    private requestConfig: AxiosRequestConfig = null;
    private configUrl: string = '';
    private netAPIUrl: string = '';
    public async put(request: IHttpRequest): Promise<AxiosResponse> {
        let response: AxiosResponse = null;
        this.resetRequestConfig();
        if (request.XChatModsAuthorization !== null) {
            this.addHeader('x-chatmods-authorization', request.XChatModsAuthorization);
        }
        this.addHeadersFromRequest(request);
        this.addHeader('content-type', request.Content);
        this.addHeader('x-chatmods-country', this.getUserPreferredCountry());
        if (!this.getHeader('authorization')) {
            this.addHeader('authorization', this.getJwt());
        }

        response = await Axios.put(`${this.configUrl}${request.Url}`, request.Payload, this.requestConfig)
                            .catch((error) => { throw new Error(error); });
        return response;
    }

    public async post(request: IHttpRequest, useNewEndPoint?: boolean): Promise<AxiosResponse> {
        let response: AxiosResponse = null;
        this.resetRequestConfig();
        if (request.XChatModsAuthorization !== null) {
            this.addHeader('x-chatmods-authorization', request.XChatModsAuthorization);
        }
        this.addHeadersFromRequest(request);
        this.addHeader('content-type', request.Content);
        this.addHeader('x-chatmods-country', this.getUserPreferredCountry());
        if (!this.getHeader('authorization')) {
            this.addHeader('authorization', this.getJwt());
        }

        response = await Axios.post(`${this.getBaseURL(useNewEndPoint)}${request.Url}`, request.Payload, this.requestConfig)
                            .catch((error) => { throw new Error(error); });
        return response;
    }

    public async delete(request: IHttpRequest): Promise<AxiosResponse> {
        let response: AxiosResponse = null;
        this.resetRequestConfig();
        if (request.XChatModsAuthorization !== null) {
            this.addHeader('x-chatmods-authorization', request.XChatModsAuthorization);
        }
        this.addHeadersFromRequest(request);
        this.addHeader('content-type', request.Content);
        this.addHeader('x-chatmods-country', this.getUserPreferredCountry());
        if (!this.getHeader('authorization')) {
            this.addHeader('authorization', this.getJwt());
        }

        response = await Axios.delete(`${this.configUrl}${request.Url}`, this.requestConfig)
                            .catch((error) => { throw new Error(error); });
        return response;
    }

    public async get(request: IHttpRequest, useNewEndPoint?: boolean, overrideCountryCode?: string): Promise<AxiosResponse> {
        let response: AxiosResponse = null;
        this.resetRequestConfig();
        if (request.XChatModsAuthorization !== null) {
            this.addHeader('x-chatmods-authorization', request.XChatModsAuthorization);
        }
        this.addHeadersFromRequest(request);
        this.addHeader('content-type', request.Content);
        this.addHeader('x-chatmods-country', overrideCountryCode ? overrideCountryCode : this.getUserPreferredCountry());
        this.addHeader('authorization', this.getJwt());
        response = await Axios.get(`${this.getBaseURL(useNewEndPoint)}${request.Url}`, this.requestConfig)
                                .catch((error) => { throw new Error(error); });
        this.requestConfig = null;
        return response;
    }

    private addHeadersFromRequest(request: IHttpRequest): void {
        if (request.Headers) {
            for (const header in request.Headers) {
                if (request.Headers.hasOwnProperty(header)) {
                    this.addHeader(header, request.Headers[header]);
                }
            }
        }
    }

    private addHeader(key: string, value?: string) {
        this.requestConfig.headers[key] = (value === undefined ? 'application/json' : value);
    }

    private getHeader(key: string): any {
        return this.requestConfig.headers[key];
    }

    private resetRequestConfig(): void {
        this.requestConfig = {
            headers: {
            }
        };
    }
    private getBaseURL(useNewEndPoint?: boolean): string{
        return useNewEndPoint === true ? this.netAPIUrl : this.configUrl;
    }
}

export { HttpService };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/http/http-service.ts